import {
  Injectable,
  ComponentRef,
  ApplicationRef,
  createComponent,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { AuctionSpinnerComponent } from '../app/auction-spinner/auction-spinner.component';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private spinnerRef: ComponentRef<AuctionSpinnerComponent> | null = null;

  constructor(private readonly appRef: ApplicationRef,@Inject(PLATFORM_ID) private  readonly platformId: any) {}

  show(): void {
    if (!this.spinnerRef) {

      // Create the component using createComponent method
      this.spinnerRef = createComponent(AuctionSpinnerComponent, {
        environmentInjector: this.appRef.injector,
      });

      // Attach the view to the application
      this.appRef.attachView(this.spinnerRef.hostView);

      // Append the component to the DOM
      const domElem = (this.spinnerRef.hostView as any)
        .rootNodes[0] as HTMLElement;
      if (isPlatformBrowser(this.platformId))
        document.body.appendChild(domElem);

    }
  }

  hide(): void {
    if (this.spinnerRef) {

      // Detach and destroy the spinner component
      this.appRef.detachView(this.spinnerRef.hostView);
      this.spinnerRef.destroy();
      this.spinnerRef = null;

    } 
  }
}
